<template>
  <v-autocomplete
      ref="el"
      v-model="localSelect"
      :items="items"
      :label="name"
      :search-input.sync="localSearchText"
      :background-color="typeof backgroundColor!=='undefined' ? backgroundColor : null"
      item-value="id"
      :item-text="getItemText"
      return-object
      :outlined="!$tools.isDefined(flat)"
      :dense="!$tools.isDefined(flat)"
      :placeholder="$tools.isEmpty(placeholder) ? null : placeholder"
      :flat="$tools.isDefined(flat)"
      :solo="$tools.isDefined(flat)"
      hide-details="auto"
      class="autocomplete"
      style="margin-bottom: 16px"
      :disabled="typeof disabled==='undefined' ? false : disabled"
      @click="items.length===0 ? $emit('load') : null"
      @focus="$emit('open');$tools.debounce(()=>{$refs.el.focus();}, 10, 'autocomplete_single')"
      :error-messages="typeof required!=='undefined' && (!localSelect||Object.keys(localSelect).length===0) ? 'Поле обязательно' : null"
      :filter="exclude ? (item, queryText, itemText) => {return !exclude.includes(item.id)&&itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1} : (item, queryText, itemText)=>{return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1}"
      :clearable="typeof clearable !=='undefined'"
  >
    <template v-slot:prepend-inner>
      <v-icon v-if="!$tools.isEmpty(icon)">{{ icon }}</v-icon>
    </template>
    <template v-slot:append>
      <v-sheet v-if="localLoading" width="24" height="24" class="d-flex align-center justify-center">
        <v-progress-circular color="primary" size="16" width="2" indeterminate/>
      </v-sheet>
    </template>
    <template v-slot:no-data>
      <div v-if="localLoading"></div>
      <v-list-item v-else>
        <v-list-item-content>
          <v-list-item-title>{{ $tools.isEmpty(items) ? 'Введите текст...' : 'Не найдено' }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-slot:item="{item}">
      <template v-if="$scopedSlots.customInfo">
        <slot name="customInfo" v-bind:item="item"/>
      </template>
      <div v-else class="v-list-item__title my-2 d-inline-block">
        <v-row no-gutters class="align-center">
          <v-col cols="auto">
            <slot name="itemIcon" v-bind:item="item"/>
          </v-col>
          <v-col>
            <div>{{ typeof item._name === 'undefined' ? item.name : item._name }}</div>
            <slot name="itemInfo" v-bind:item="item"/>
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-slot:selection="{item}">
      <chip :class="(typeof name==='undefined' ? '' : 'mt-1')" fullWidth>

        <v-row no-gutters class="align-center text-left">
          <v-col :class="typeof textOverflow !== 'undefined' ? 'text-overflow':''">
            <slot name="selectedInfo" v-bind:item="item">
              {{ typeof item._selected_name === 'undefined' ? item.name : item._selected_name }}
            </slot>
          </v-col>
          <v-col v-if="readonly!==true" cols="auto" class="pl-2">
            <v-icon small @click.stop="localSelect=null">mdi-close-circle</v-icon>
          </v-col>
        </v-row>

      </chip>
    </template>
  </v-autocomplete>
</template>

<script>
import Chip from "@/componentsV2/base/Chip.vue";

export default {
  components: {Chip},
  props: ['name', 'items', 'select', 'searchText', 'loading', 'backgroundColor', 'required', 'readonly', 'textOverflow', 'disabled', 'clearable', 'exclude', 'icon', 'flat', 'placeholder'],
  data: () => ({
    localSelect: {},
    localSearchText: null,
    localLoading: false,
  }),
  mounted() {
    this.localSelect = this.select;
  },
  watch: {
    select() {
      this.localSelect = this.select
      this.localSearchText = null;
    },
    localSelect() {
      if (typeof this.localSelect !== 'undefined') {
        this.$emit('update:select', this.localSelect)
        this.$refs.el.blur()
      }
    },
    loading() {
      this.localLoading = this.loading;
    },
    localLoading() {
      this.$emit('update:loading', this.loading)
    },
    searchText() {
      this.localSelects = this.searchText;
    },
    localSearchText() {
      this.$tools.debounce(() => {
        this.$emit('update:searchText', this.localSearchText)
      })
    },
  },
  methods: {
    getItemText(item) {
      if (typeof item.firstName !== 'undefined')
        return `${item.id} - ${item.lastName} ${item.firstName} ${item.secondName}`;
      else
        return `${item.id} - ${item.name}`;
    },
    open() {
      setTimeout(() => {
        this.$refs.el.focus()
      }, 500)
    }
  }
}
</script>